module.exports = __webpack_public_path__ + "static/media/historical-marker-soil.7f1a7c52.svg";